import React from 'react'



function PaymentHistory({ paymentHistory }) {
    const formatDate = (dateValue) => {
        if (!dateValue || typeof dateValue !== 'string') {
            return ''
        }

        return dateValue.includes('T') ? dateValue.split('T')[0] : dateValue
    }

    const formatText = (value) => {
        if (value === null || value === undefined || `${value}`.trim() === '') {
            return 'N/A'
        }

        return value
    }

    return (
        <div className='notes-wrapper' >
            <div className='commntsText padding card'>

                <table>
                    <thead>
                        <tr>
                            <th>Payment Date</th>
                            <th>Payment Amount</th>
                            <th>Status</th>
                            <th>Deposit Date</th>
                            <th>Payment Type</th>
                            <th>Collection Type</th>
                            <th>Collector</th>
                            <th> Remit Amount</th>
                            <th> Remit Date</th>
                        </tr>
                    </thead>


                    <tbody>
                        {paymentHistory.map(item => (<tr key={item.paymentID}>
                            <td>{formatDate(item.paymentDate)}</td>
                            <td>$ {item.paymentAmount}</td>
                            <td>{formatText(item.checkStatus)}</td>
                            <td>{formatDate(item.deposit_Date)}</td>
                            <td>{formatText(item.paymentMethod)}</td>
                            <td>{formatText(item.collection_Type)}</td>
                            <td>{formatText(item.collector)}</td>
                            <td>$ {item.remit_Amount}</td>
                            <td>{formatDate(item.dateRemitted)}</td>
                        </tr>))}

                    </tbody>

                </table>


            </div>
        </div>
    )
}

export default PaymentHistory
